import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

function BackBtn({ title }) {

    let navigate = useNavigate();
    const goBackHome = useCallback(() => {
        navigate('/home', { replace: true });
    }, [navigate]);

    return (
        <div className="back-button" onClick={goBackHome}>stormsalpha:\{title.toLowerCase()}&gt; cd ../</div>
    );
}

export default BackBtn;